import { Size, Variant } from '~/src/components/generic/Button/types'

export const variantClasses: Record<Variant, string> = {
  primary:
    'bg-gray-700 border border-gray-700 text-white hover:bg-gray-800 hover:border-gray-800 active:border-gray-800 disabled:text-gray-0 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:border-gray-300',
  secondary:
    'hover:bg-gray-100 hover:text-gray-700 hover:border-gray-500 active:border-gray-500 text-gray-700 disabled:text-gray-300 disabled:border-gray-300 disabled:cursor-not-allowed border border-gray-500 disabled:shadow-none',
  link: 'text-label-s text-blue-600 underline tracking-wide underline-offset-2 hover:bg-blue-50 p-1 disabled:text-gray-400 disabled:cursor-not-allowed font-medium',
}

export const sizeClasses: Record<Size, string> = {
  md: 'text-label-s tracking-wide',
  lg: 'text-label-l font-normal shadow',
}
